import { AfterViewInit, ChangeDetectionStrategy, Component, inject, ViewChild } from '@angular/core';
import { LoginFormComponent } from '@technocom/auth';
import type { PlainObject } from '@technocom/common/platform';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { TextBoxComponent } from '@progress/kendo-angular-inputs';
import { RouterService } from '@technocom/core';
import { DialogService } from '@technocom/ui/dialogs';

@Component({
  selector: 'app-login-phone-page',
  templateUrl: './login-phone-page.component.html',
  styleUrls: ['./login-phone-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginPhonePageComponent extends LoginFormComponent implements AfterViewInit {
  @ViewChild('passwordbox') public passwordbox: TextBoxComponent;
  fetching: boolean;

  public ngAfterViewInit(): void {
    this.passwordbox.input.nativeElement.type = 'password';
    this.formData.login = '';
    this.formData.password = '';
  }

  get localizeBasePath(): string {
    return 'profile.login';
  }

  get isSubmitBtnDisabled(): boolean {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
    return _.isEmpty(_.trim(this.formData.login)) || _.isEmpty(_.trim(this.formData.password));
  }

  protected router = inject(Router);
  protected routerService = inject(RouterService);
  protected dialogService = inject(DialogService);
  protected override getFormDefaults(): PlainObject {
    return {};
  }

  goToRecovery(): void {
    this.router.navigateByUrl('/recovery');
  }

  send() {
    if (!!this.formData.login && this.formData.password) {
      this.submit().then(() => {
        this.dialogService.wait(this.routerService.open('profile/person-helper', true));
      });
    }
  }

  // смена видимости ввода пароля
  public toggleVisibility(): void {
    const inputEl = this.passwordbox.input.nativeElement;

    if (inputEl.type === 'password') {
      inputEl.type = 'text';
    } else {
      inputEl.type = 'password';
    }
  }
}
